import { RegisterWizard } from "@/components/auth/register-wizard";

export default function RegisterPage() {
  return <RegisterWizard />;
}
